<template>
  <b-container fluid>
    <b-card
      class="mt-5"
      style="
        width: 350px;
        display: table;
        margin-right: auto;
        margin-left: auto;
      "
    >
      <div class="text-center m-3">
        <b-img
          fluid
          alt="Email Confirmation"
          :src="icon"
          style="width: 128px"
        />
      </div>
      <legend class="text-center" :style="style">
        {{ header }}
      </legend>
      <p class="text-center" style="font-weight: 400">
        {{ subheader }}
      </p>
      <div>
        <b-button
          to="/pmse"
          target="_blank"
          size="sm"
          variant="outline-success"
          class="w-100"
          v-if="header == 'Terima kasih'"
          >Ke Halaman Login</b-button
        >
      </div>
    </b-card>
  </b-container>
</template>
<script>
import AuthService from "../../../services/AuthService"
// import dataEmail from "./../data.json"
export default {
  name: "EmailVerifyPmse",
  components: {},
  data: () => {
    return {
      icon: "../img/mail_confirmation.svg",
      style: "font-weight: 500; color: #09cc9a",
      header: "Terima kasih",
      subheader:
        "Email Anda berhasil diverifikasi, selanjutnya silakan Login, kemudian lengkapi profil Anda untuk mengakses sistem ini.",
    }
  },
  mounted() {
    this.verifikasi(this.$route.params.code)
  },
  methods: {
    async verifikasi(code) {
      await AuthService.verifyEmail(code).then(
        () => {
          // console.log(result.data)
        },
        (error) => {
          if (error.response) {
            this.icon = "../img/mail_confirmation_invalid.svg"
            this.style = "font-weight: 500; color: #ff6884"
            this.header = "Kode Tidak Valid"
            this.subheader =
              "Mohon maaf, kode verifikasi tidak valid pastikan melakukan konfirmasi melalui link yang dikirimkan ke alamat email yang digunakan saat registrasi."
          }
        }
      )
    },
  },
}
</script>
